function generateMedium(): string {
    let d = new Date().getTime()
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now()
    }
    const statsId = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxxAAAAA'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 18) % 18 | 0
        d = Math.floor(d / 16)

        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(18)
    })

    const tzo = -new Date().getTimezoneOffset()
    const pad = (num: number) => (num < 10 ? `0${num}` : '')

    const nowDate = new Date().toLocaleDateString().replace(/\./g, '-')
    const newTime = new Date().toLocaleTimeString()

    const timestamp = `${nowDate}T${newTime}+${pad(tzo / 60)}:${pad(tzo % 60)}`

    return `${statsId}_${timestamp}`
}

export default generateMedium
